<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Personas que usan el sistema. Crea, desactiva
                o edita usuarios y sus datos de inicio de sesión.
                Úsalo para dar alta a alguien nuevo o retirar acceso
                cuando se va.
              </p>
            </div>
          </mat-menu>
        <h2 class="text-xl font-semibold leading-8 tracking-tight">
          Usuarios
        </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>usuarios</b> para el acceso a la plataforma AVE.
        </div>
      </div>

      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <!-- Title -->
          <!-- <div class="text-3xl font-extrabold tracking-tight">Usuarios</div> -->          
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo Registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSource"
              matSort
              (matSortChange)="changeSort($event)"
              matSortDisableClear
              multiTemplateDataRows
            >
              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" style="width: 5px">
                  <button
                    class="min-h-7 min-w-10 px-2 leading-6"
                    mat-icon-button
                    (click)="toggleDetails(element)"
                    style="margin-left: 10px"
                  >
                    <mat-icon
                      class="icon-size-5"
                      [svgIcon]="
                        selectedPermission?._id === element._id
                          ? 'heroicons_solid:chevron-up'
                          : 'heroicons_solid:chevron-down'
                      "
                    ></mat-icon>
                  </button>
                </td>
              </ng-container>

              <!-- Usuario -->
              <ng-container matColumnDef="user_login_username">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Usuario
                </th>
                <td mat-cell *matCellDef="let element" class="text-sm">
                  {{ element.user_login_username }}
                </td>
              </ng-container>

              <!-- Correo -->
              <ng-container matColumnDef="user_login_email">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Correo Electrónico
                </th>
                <td mat-cell *matCellDef="let element" class="text-sm">
                  {{ element.user_login_email }}
                </td>
              </ng-container>

              <!-- Nombre -->
              <ng-container matColumnDef="user_login_first_name">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Nombre y Apellidos
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="text-sm uppercase"
                >
                  {{ element.user_login_first_name }}
                  {{ element?.user_login_last_name }}
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="type">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Tipo de Usuario
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="text-sm uppercase"
                >
                  {{ element.type ? element.type : "AVE" }}
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="action">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="px-6 py-3 text-left"
                ></th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="px-6 py-3 text-left"
                >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionMenu"
                    matTooltip="Acciones"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(element)">
                      <mat-icon
                        svgIcon="heroicons_outline:pencil-square"
                      ></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openLinkedDevice(element)">
                      <mat-icon svgIcon="heroicons_outline:device-phone-mobile"></mat-icon>
                      <span>Dispositivos Vinculados</span>
                    </button>
                    <button mat-menu-item (click)="openCreatePasswordModal(element)">
                      <mat-icon svgIcon="heroicons_outline:lock-closed"></mat-icon>
                      <span>Generar contraseña temporal</span>
                    </button>
                    <button mat-menu-item (click)="deleteUser(element)">
                      Eliminar
                      <mat-icon>delete</mat-icon>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td
                  mat-cell
                  *matCellDef="let element"
                  [attr.colspan]="displayedColumns.length"
                >
                  <tr
                    *ngIf="selectedPermission?._id === element._id"
                    class="details-row"
                  >
                    <td [attr.colspan]="displayedColumns.length">
                      <ng-container
                        *ngTemplateOutlet="
                          rowDetailsTemplate;
                          context: { $implicit: element }
                        "
                      ></ng-container>
                    </td>
                  </tr></td
              ></ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="border-b h-16"
                [class.table-expanded-row]="selectedPermission?._id === row._id"
              ></tr>

              <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="table-detail-row"
              ></tr>
            </table>
          </div>
          <div
            *ngIf="this.dataSource.data.length === 0"
            class="border-t p-8 text-center text-1xl sm:p-10"
          >
            Lo sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize-->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageSize]="pageSize"
            (page)="changePage($event)"
          ></mat-paginator>
        </div>
      </div>

      <ng-template #rowDetailsTemplate let-user>
        <div class="overflow-hidden">
          <div class="flex">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-4 px-2 sm:flex-row">
                <div class="container flex-auto flex-col w-full">
                  <div class="p-2 flex w-full">
                    @if (
                      selectedPermission.parents &&
                      selectedPermission.parents.length > 0
                    ) {
                      <mat-tab-group>
                        <mat-tab
                          *ngFor="let parent of selectedPermission.parents"
                          [label]="parent.name"
                        >
                          <div>
                            <ul>
                              <li *ngFor="let child of parent.children">
                                <mat-checkbox
                                  [(ngModel)]="child.selected"
                                  [ngModelOptions]="{ standalone: true }"
                                >
                                  {{ child.name }}
                                </mat-checkbox>
                              </li>
                            </ul>
                          </div>
                        </mat-tab>
                      </mat-tab-group>
                    }
                    <div
                      *ngIf="this.selectedPermission.parents.length === 0"
                      class="p-8 text-center text-1xl sm:p-10"
                    >
                      Lo sentimos, no hay registros para mostrar.
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </ng-template>

      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
        <mat-dialog-content class="modal-content">
          <form [formGroup]="createForm">
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Nombre(s)</mat-label>
                <input
                  matInput
                  formControlName="first_name"
                  name="first_name"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Apellidos(s)</mat-label>
                <input matInput formControlName="last_name" name="last_name" />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput formControlName="email" name="email" required />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Usuario</mat-label>
                <input
                  matInput
                  formControlName="username"
                  name="username"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="type" name="type" (selectionChange)="changeType()">
                  <mat-option value="null">Ninguno</mat-option>
                  @for (type of typeMasterUserList; track type) {
                  <mat-option [value]="type">
                      {{ type }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if(createForm.get('type')?.value && createForm.value.type === MasterUserTypeEnum.CSMOBILE_FISCAL){
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Oficina de venta</mat-label>
                <mat-select formControlName="salesOfficeIds" name="salesOfficeIds" multiple placeholder="Seleccione Oficina de venta">
                  <mat-option *ngFor="let type of salesOfficeList || []" [value]="type._id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              }

              @if(createForm.get('type')?.value && createForm.value.type === 'SOCIOS DE NEGOCIO'){
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Socios de Negocio<span matRequiredMarker>*</span></mat-label>
                  <mat-select formControlName="businessPartnerId" name="businessPartnerId">
                      <mat-option>
                          <ngx-mat-select-search [(ngModel)]="searchBusiness" [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="changueOptionsBusiness($event)" placeholderLabel="Buscar socio..."
                              noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                      </mat-option>
                      @for (business of businessPartnerList; track business) {
                      <mat-option [value]="business._id">
                          <b *ngIf="getCode(business) as code">{{ code }} - </b>{{ business.name }}
                      </mat-option>
                      }
                  </mat-select>
                  <mat-error *ngIf="createForm.errors?.businessPartnerRequired && createForm.get('businessPartnerId')?.touched">
                    El campo Socio de Negocio es obligatorio.
                  </mat-error>
                </mat-form-field>
              }
              
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Contraseña</mat-label>
                <input
                  matInput
                  formControlName="password"
                  aria-label="Contraseña"
                  [type]="!hide ? 'password' : 'text'"
                  minlength="3"
                  maxlength="100"
                  required
                />
                <mat-icon
                  style="cursor: pointer"
                  class="text-muted"
                  matSuffix
                  (click)="hide = !hide"
                >
                  {{ !hide ? "visibility_off" : "visibility" }}
                </mat-icon>
                <mat-error
                  *ngIf="createForm.get('password').hasError('minlength')"
                >
                  La contraseña debe tener al menos 3 caracteres
                </mat-error>
                <mat-error
                  *ngIf="
                    createForm.get('password').hasError('hasNumber') ||
                    createForm.get('password').hasError('hasCapitalCase')
                  "
                >
                  Debe incluir al menos un número y una letra mayúscula
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Repetir Contraseña</mat-label>
                <input
                  matInput
                  formControlName="password_confirmation"
                  name="password_confirmation"
                  [type]="!hidenew ? 'password' : 'text'"
                  required
                />
                <mat-icon
                  style="cursor: pointer"
                  class="text-muted"
                  matSuffix
                  (click)="hidenew = !hidenew"
                >
                  {{ !hidenew ? "visibility_off" : "visibility" }}</mat-icon
                >
                <mat-error
                  *ngIf="
                    createForm
                      .get('password_confirmation')
                      .hasError('mismatchedPasswords')
                  "
                >
                  La contraseña no coincide
                </mat-error>
              </mat-form-field>
              <!--Req: no show allow_shared_user-->
              @if(false){
              <p class="mt-6">
                <mat-slide-toggle
                  labelPosition="before"
                  color="primary"
                  [checked]="createForm.value.allow_shared_user === true"
                  (change)="
                    $event.checked
                      ? createForm.get('allow_shared_user').setValue(true)
                      : createForm.get('allow_shared_user').setValue(false)
                  "
                >
                  ¿Permite Múltiples Cuentas?</mat-slide-toggle
                >
              </p>
              }
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Aplicaciones</mat-label>
                <mat-select formControlName="permissionsSA" multiple>
                  @for (aplication of applicationList; track aplication) {
                    <mat-optgroup [label]="aplication.name">
                      @for (
                        subaplication of aplication.subApplications;
                        track subaplication
                      ) {
                        <mat-option
                          [value]="{
                            parentId: aplication._id,
                            subId: subaplication._id,
                          }"
                          >{{ subaplication.name }}</mat-option
                        >
                      }
                    </mat-optgroup>
                  }
                </mat-select>
              </mat-form-field>

              <app-role-multi-select
                [control]="$any(createForm.get('roleIds'))"
                [multiple]="true">
              </app-role-multi-select>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Cantidad de dispositivos vinculados</mat-label>
                <input matInput type="number" formControlName="quantity_identifiers" name="quantity_identifiers" min="1" max="10" required/>
              </mat-form-field>
            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button
            color="primary"
            (click)="createUserNew()"
            [disabled]="!createForm.valid"
          >
            Guardar
          </button>
        </mat-dialog-actions>
      </ng-template>

      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
        <mat-dialog-content class="modal-content">
          <form [formGroup]="editForm">
            <div class="grid grid-cols-2 gap-x-4 items-center">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Nombre(s)</mat-label>
                <input
                  matInput
                  formControlName="first_name"
                  name="first_name"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Apellidos(s)</mat-label>
                <input matInput formControlName="last_name" name="last_name" />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput formControlName="email" name="email" required />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Usuario</mat-label>
                <input
                  matInput
                  formControlName="username"
                  name="username"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="type" name="type" (selectionChange)="changeType()">
                  <mat-option value="null">Ninguno</mat-option>
                  @for (type of typeMasterUserList; track type) {
                  <mat-option [value]="type">
                      {{ type }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if(editForm.get('type')?.value && editForm.value.type === MasterUserTypeEnum.CSMOBILE_FISCAL){
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Oficina de venta</mat-label>
                <mat-select formControlName="salesOfficeIds" name="salesOfficeIds" multiple placeholder="Seleccione Oficina de venta">
                  <mat-option *ngFor="let type of salesOfficeList || []" [value]="type._id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              }

              @if(editForm.get('type')?.value && editForm.value.type === 'SOCIOS DE NEGOCIO'){
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Socios de Negocio<span matRequiredMarker>*</span></mat-label>
                  <mat-select formControlName="businessPartnerId" name="businessPartnerId">
                      <mat-option>
                          <ngx-mat-select-search [(ngModel)]="searchBusiness" [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="changueOptionsBusiness($event)" placeholderLabel="Buscar socio..."
                              noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                      </mat-option>
                      @for (business of businessPartnerList; track business) {
                      <mat-option [value]="business._id">
                          <b *ngIf="getCode(business) as code">{{ code }} - </b>{{ business.name }}
                      </mat-option>
                      }
                  </mat-select>
                  <mat-error *ngIf="editForm.errors?.businessPartnerRequired && editForm.get('businessPartnerId')?.touched">
                    El campo Socio de Negocio es obligatorio.
                  </mat-error>
                </mat-form-field>
              }

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Aplicaciones</mat-label>
                <mat-select formControlName="permissionsSA" multiple>
                  @for (aplication of applicationList; track aplication) {
                    <mat-optgroup [label]="aplication.name">
                      @for (
                        subaplication of aplication.subApplications;
                        track subaplication
                      ) {
                        <mat-option [value]="subaplication._id">{{
                          subaplication.name
                        }}</mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
              </mat-form-field>

              <app-role-multi-select
                [control]="$any(editForm.get('roleIds'))"
                [multiple]="true">
              </app-role-multi-select>

              <div *ngIf="!editPassword" class="col-span-1 flex">
                <mat-slide-toggle
                  color="primary"
                  [(ngModel)]="editPassword"
                  [ngModelOptions]="{ standalone: true }"
                >
                  Editar Contraseña
                </mat-slide-toggle>
              </div>
              @if (editPassword) {
                <!-- <mat-form-field appearance="fill" class="w-full">
                  <mat-label>
                    Contraseña Actual*
                    <mat-slide-toggle
                      [(ngModel)]="editPassword"
                      (change)="onPasswordChange()"
                      [ngModelOptions]="{ standalone: true }"
                      color="primary"
                    >
                      Editar Contraseña
                    </mat-slide-toggle>
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="old_password"
                    [ngModelOptions]="{ standalone: true }"
                    aria-label="Contraseña Actual"
                    [type]="!hideold ? 'password' : 'text'"
                    minlength="3"
                    maxlength="100"
                  />
                  <mat-icon
                    style="cursor: pointer"
                    class="text-muted"
                    matSuffix
                    (click)="hideold = !hideold"
                  >
                    {{ !hideold ? "visibility_off" : "visibility" }}
                  </mat-icon>
                </mat-form-field> -->
                <mat-slide-toggle
                  [(ngModel)]="editPassword"
                  (change)="onPasswordChange()"
                  [ngModelOptions]="{ standalone: true }"
                  color="primary"
                >
                  Editar Contraseña
                </mat-slide-toggle>
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>{{
                    !isExist ? "Contraseña" : "Nueva Contraseña"
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="password"
                    aria-label="Contraseña"
                    [type]="!hide ? 'password' : 'text'"
                    minlength="3"
                    maxlength="100"
                  />
                  <mat-icon
                    style="cursor: pointer"
                    class="text-muted"
                    matSuffix
                    (click)="hide = !hide"
                  >
                    {{ !hide ? "visibility_off" : "visibility" }}
                  </mat-icon>
                  <mat-error
                    *ngIf="editForm.get('password').hasError('minlength')"
                  >
                    La contraseña debe tener al menos 3 caracteres
                  </mat-error>
                  <mat-error
                    *ngIf="
                      editForm.get('password').hasError('hasNumber') ||
                      editForm.get('password').hasError('hasCapitalCase')
                    "
                  >
                    Debe incluir al menos un número y una letra mayúscula
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Repetir Contraseña</mat-label>
                  <input
                    matInput
                    formControlName="password_confirmation"
                    name="password_confirmation"
                    [type]="!hidenew ? 'password' : 'text'"
                  />
                  <mat-icon
                    style="cursor: pointer"
                    class="text-muted"
                    matSuffix
                    (click)="hidenew = !hidenew"
                  >
                    {{ !hidenew ? "visibility_off" : "visibility" }}</mat-icon
                  >
                  <mat-error
                    *ngIf="
                      editForm
                        .get('password_confirmation')
                        .hasError('mismatchedPasswords')
                    "
                  >
                    La contraseña no coincide
                  </mat-error>
                </mat-form-field>
              }
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Cantidad de dispositivos vinculados</mat-label>
                <input matInput type="number" formControlName="quantity_identifiers" name="quantity_identifiers" min="1" max="10" required/>
              </mat-form-field>
            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button
            color="primary"
            (click)="updateUser()"
            [disabled]="!editForm.valid"
          >
            Guardar
          </button>
        </mat-dialog-actions>
      </ng-template>
    </div>
  </div>

  <ng-template #actionModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ selectedPasswordId ? 'Editar' : 'Nueva' }} Contraseña
        </h2>
        <mat-dialog-content class="modal-content">
            <form [formGroup]="passwordForm" class="space-y-4">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Usuario</mat-label>
                <input matInput [value]="userSelectedForPassword" disabled />
              </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Motivo</mat-label>
                    <input matInput formControlName="reason" placeholder="Motivo de la contraseña temporal" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Duración (horas)</mat-label>
                    <input matInput type="number" formControlName="durationInHours" min="1" max="8"/>
                    <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('required')">
                      La duración es obligatoria
                    </mat-error>
                    <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('min')">
                      La duración debe ser al menos 1 hora
                    </mat-error>
                    <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('max')">
                      La duración no puede ser mayor a 8 horas
                    </mat-error>
                </mat-form-field>

            </form>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button mat-raised-button color="primary" (click)="onSubmitPassword()" [disabled]="!passwordForm.valid">
                Guardar
            </button>
        </mat-dialog-actions>
    </ng-template>
</mat-sidenav-container>

<!-- Confirmar modificaciones -->

<ng-template #alertDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px"
        >warning_amber</mat-icon
      >
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button
      mat-button
      mat-dialog-close
      class="align-left mr-3"
      [mat-dialog-close]="false"
    >
      No
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Si
    </button>
  </mat-dialog-actions>
</ng-template>
